import { defer } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { action$, ofType } from '@ardoq/rxbeach';
import { filterInterface } from '@ardoq/filter-interface';
import { notifyFiltersChanged } from './FilterActions';

const getActiveComponentColors = (): { colors: string[] } => ({
  colors: [
    ...new Set(
      filterInterface
        .getFormattingFilters()
        .filter(({ color, affectComponent }) => color && affectComponent)
        .map(({ color }) => color)
    ),
  ],
});

export const activeComponentColors$ = defer(() =>
  action$.pipe(
    ofType(notifyFiltersChanged),
    map(getActiveComponentColors),
    startWith(getActiveComponentColors())
  )
);
